__turbopack_context__.v({
  "blink": "lD9PbW_blink",
  "caret": "lD9PbW_caret",
  "eyebrow": "lD9PbW_eyebrow",
  "message": "lD9PbW_message",
  "panel": "lD9PbW_panel",
});
